import { IUserStore } from './types';

const initStore: IUserStore = {
  current: null,
  authorized: false,
  authChecked: false,
};

export default initStore;
